import type { JSX, ReactNode } from 'react'

import { clsx } from 'clsx'

import { Flex, Sidebar } from '@buffer-mono/popcorn'

import { SidebarEdgeTrigger } from '../SidebarEdgeTrigger'

import styles from '../../MainSidebar.module.css'

export function MainSidebarFrame({
  open,
  onOpenChange,
  showEdgeTrigger = true,
  children,
}: {
  open?: boolean
  onOpenChange?: (open: boolean) => void
  showEdgeTrigger?: boolean
  children: ReactNode
}): JSX.Element {
  return (
    <Sidebar
      collapsible="icon"
      as="nav"
      className={styles.sidebar}
      aria-label="Sidebar"
      open={open}
      onOpenChange={onOpenChange}
    >
      {children}
      {showEdgeTrigger ? <SidebarEdgeTrigger /> : null}
    </Sidebar>
  )
}

export function MainSidebarHeader({
  logo,
  globalButton,
  navigation,
}: {
  logo: ReactNode
  globalButton: ReactNode
  navigation?: ReactNode
}): JSX.Element {
  return (
    <Sidebar.Header>
      <Flex direction="column">
        <Flex direction="column" fullWidth className={styles.headerActions}>
          <Flex
            gap="sm"
            align="center"
            justify="between"
            fullWidth
            className={styles.logoContainer}
          >
            {logo}
          </Flex>
          {globalButton}
        </Flex>
        {navigation}
      </Flex>
    </Sidebar.Header>
  )
}

export function MainSidebarFooter({
  impersonation = false,
  children,
}: {
  impersonation?: boolean
  children: ReactNode
}): JSX.Element {
  return (
    <Sidebar.Footer
      className={clsx(
        styles.footer,
        impersonation && styles.footerImpersonation,
      )}
    >
      {children}
    </Sidebar.Footer>
  )
}
